module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/arm-5ef1956944889a4c1f74e55437d8fa30.png";